<template>
  <div>
    <ElButton type="primary" size="mini" plain @click="showEditModal">
      {{ $t('EDIT') }}
    </ElButton>
    <DeleteWithConfirm :delete-function="handleDeleteEmail">
      {{ $t('REMOVE') }}
    </DeleteWithConfirm>

    <MailServicePageEditModal
      v-model="shouldShowEdtiModal"
      :notification-properties="row"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import DeleteWithConfirm from '@@/common/action-buttons/DeleteWithConfirm';
import MailServicePageEditModal from './MailServicePageEditModal';
import { DELETE_MAIL_SERVICE } from '@/store/types';
import {
  AD_MAIL_SERVICE_EDIT_BUTTON,
  AD_MAIL_SERVICE_REMOVE_BUTTON,
} from '@/constants/gtm-events';

export default {
  name: 'MailServicePageListActionsColumn',
  components: { DeleteWithConfirm, MailServicePageEditModal },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      shouldShowEdtiModal: false,
    };
  },
  methods: {
    ...mapActions({
      deleteEmail: DELETE_MAIL_SERVICE,
    }),
    handleDeleteEmail() {
      this.$gtm.trackEvent(AD_MAIL_SERVICE_REMOVE_BUTTON);

      return this.deleteEmail(this.row.id)
        .then(message => {
          this.$message.success(message);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
    showEditModal() {
      this.$gtm.trackEvent(AD_MAIL_SERVICE_EDIT_BUTTON);

      this.shouldShowEdtiModal = true;
    },
  },
};
</script>
